module.exports = __webpack_public_path__ + "img/product21p.273238e0.png";